module.exports = __webpack_public_path__ + "img/save.7e6f89fd.svg";